var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPotionFlask = function SvgPotionFlask(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1158_31134)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 105
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7978 27.5857C79.8113 23.7711 77.5114 18.1195 72.6654 17.4314L46.6516 13.7373C41.8222 13.0515 38.0836 17.8129 39.916 22.3157L45.7856 36.7388L21.4192 67.5822C15.3715 75.2376 19.9043 86.5679 29.5634 87.9396L69.3626 93.5913C79.0217 94.963 86.5296 85.3425 82.8522 76.3061L67.8028 39.3257C67.7711 39.248 67.7389 39.1708 67.706 39.0942L76.7978 27.5857Z",
    fill: "url(#paint0_linear_1158_31134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.897 72.0917C66.9846 57.1092 48.2625 72.5658 45.2254 75.9661C53.2738 77.7476 73.019 81.7008 77.597 81.8401C83.3194 82.0141 83.4226 75.4444 80.897 72.0917Z",
    fill: "url(#paint1_linear_1158_31134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6211 87.5169L50.1553 90.7169C55.7888 91.517 67.807 93.2237 70.8115 93.6502C74.5673 94.1834 81.5378 90.0651 82.9637 84.5204C84.3897 78.9758 82.8674 76.2051 80.897 72.0938C82.3304 75.4903 72.0559 84.8872 61.2296 75.6867C42.3277 59.6236 23.8467 64.631 21.5245 67.494C12.4131 77.6945 23.2394 86.8947 27.6211 87.5169Z",
    fill: "url(#paint2_linear_1158_31134)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M61.0422 57.0668C62.7396 57.0668 64.1156 55.6908 64.1156 53.9934C64.1156 52.2959 62.7396 50.9199 61.0422 50.9199C59.3448 50.9199 57.9688 52.2959 57.9688 53.9934C57.9688 55.6908 59.3448 57.0668 61.0422 57.0668Z",
    fill: "url(#paint3_linear_1158_31134)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M51.7453 41.7543C52.5366 41.7543 53.1781 41.1128 53.1781 40.3215C53.1781 39.5302 52.5366 38.8887 51.7453 38.8887C50.954 38.8887 50.3125 39.5302 50.3125 40.3215C50.3125 41.1128 50.954 41.7543 51.7453 41.7543Z",
    fill: "url(#paint4_linear_1158_31134)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M42.6563 59.6699C43.2603 59.6699 43.75 59.1802 43.75 58.5762C43.75 57.9721 43.2603 57.4824 42.6563 57.4824C42.0522 57.4824 41.5625 57.9721 41.5625 58.5762C41.5625 59.1802 42.0522 59.6699 42.6563 59.6699Z",
    fill: "url(#paint5_linear_1158_31134)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M62.8906 30.2305C64.4008 30.2305 65.625 29.0062 65.625 27.4961C65.625 25.9859 64.4008 24.7617 62.8906 24.7617C61.3805 24.7617 60.1562 25.9859 60.1562 27.4961C60.1562 29.0062 61.3805 30.2305 62.8906 30.2305Z",
    fill: "url(#paint6_linear_1158_31134)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M54.1406 12.0508C55.0467 12.0508 55.7813 11.3162 55.7813 10.4102C55.7813 9.50406 55.0467 8.76953 54.1406 8.76953C53.2345 8.76953 52.5 9.50406 52.5 10.4102C52.5 11.3162 53.2345 12.0508 54.1406 12.0508Z",
    fill: "url(#paint7_linear_1158_31134)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.3594 8.26367C70.4736 8.26367 72.1875 6.54976 72.1875 4.43554C72.1875 2.32133 70.4736 0.607422 68.3594 0.607422C66.2452 0.607422 64.5312 2.32133 64.5312 4.43554C64.5312 6.54976 66.2452 8.26367 68.3594 8.26367Z",
    fill: "url(#paint8_linear_1158_31134)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.3125,
    cy: 101.719,
    rx: 32.8125,
    ry: 2.1875,
    fill: "url(#paint9_linear_1158_31134)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1158_31134",
    x1: 70.8706,
    y1: 57.2583,
    x2: 54.0552,
    y2: 40.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1158_31134",
    x1: 73.5802,
    y1: 77.0551,
    x2: 83.0396,
    y2: 92.7142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2979FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003881",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1158_31134",
    x1: 67.5854,
    y1: 84.8909,
    x2: 65.4738,
    y2: 49.7419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2979FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1158_31134",
    x1: 62.6867,
    y1: 54.9609,
    x2: 58.7648,
    y2: 47.9456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2979FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1158_31134",
    x1: 52.512,
    y1: 40.7725,
    x2: 50.6836,
    y2: 37.5021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2979FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1158_31134",
    x1: 43.2415,
    y1: 58.9205,
    x2: 41.8458,
    y2: 56.4239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2979FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1158_31134",
    x1: 64.3537,
    y1: 28.3569,
    x2: 60.8645,
    y2: 22.1155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2979FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1158_31134",
    x1: 55.0185,
    y1: 10.9266,
    x2: 52.9249,
    y2: 7.18181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2979FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1158_31134",
    x1: 70.4077,
    y1: 5.64067,
    x2: 65.5227,
    y2: -3.09727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2979FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1158_31134",
    x1: 18.5937,
    y1: 102.594,
    x2: 78.7388,
    y2: 101.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F5FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F5FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1158_31134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 105,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPotionFlask);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "potion-flask.b5c4054e2bcc27855f742f4c08b10a2a.svg";